import { type CompanyTag, CompanyTagCategory } from "@prisma/client";
import { match } from "ts-pattern";
import { orderBy } from "~/lib/lodash";

export const formatCompanyTagCategory = (category: CompanyTagCategory): string => {
  return match(category)
    .with(CompanyTagCategory.LABEL, () => {
      return "Label";
    })
    .with(CompanyTagCategory.INDUSTRY, () => {
      return "Industry";
    })
    .with(CompanyTagCategory.REVENUE_MODEL, () => {
      return "Revenue model";
    })
    .with(CompanyTagCategory.INTERNAL, () => {
      return "Internal";
    })
    .with(CompanyTagCategory.INTERNAL_BENCHMARK, () => {
      return "Internal benchmark";
    })
    .exhaustive();
};

const TagsOrder: CompanyTagCategory[] = [
  CompanyTagCategory.LABEL,
  CompanyTagCategory.INTERNAL_BENCHMARK,
  CompanyTagCategory.REVENUE_MODEL,
  CompanyTagCategory.INDUSTRY,
];

export const orderTags = (tags: CompanyTag[]): CompanyTag[] => {
  return orderBy(tags, (tag) => {
    return TagsOrder.indexOf(tag.category);
  });
};
